import type { ClaimAppRouter } from '@/pages/api/trpc/[trpc]'
import { getAccessToken } from '@privy-io/react-auth'
import { httpLink, loggerLink } from '@trpc/client'
import { createTRPCNext } from '@trpc/next'
import superjson from 'superjson'

function getBaseUrl({ allowRelative = true }: { allowRelative: boolean }): string {
  if (allowRelative && typeof window !== 'undefined')
    // browser should use relative path
    return ''
  if (process.env.VERCEL_URL)
    // reference for vercel.com
    return `https://${process.env.VERCEL_URL}`
  // assume localhost
  return `http://localhost:3000`
}

const config = {
  config() {
    return {
      queryClientConfig: {
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
          },
        },
      },
      links: [
        loggerLink({
          enabled: () =>
            process.env.NODE_ENV === 'development' && typeof window !== 'undefined',
        }),
        httpLink({
          url: `${getBaseUrl({ allowRelative: true })}/api/trpc`,
          transformer: superjson,
          fetch(url: Parameters<typeof fetch>[0], options: Parameters<typeof fetch>[1]) {
            return fetch(url, { ...options, credentials: 'include', cache: 'no-store' })
          },
          async headers() {
            const headers = new Map<string, string>()
            const token = await getAccessToken()
            if (token) {
              headers.set('authorization', token)
            }
            return Object.fromEntries(headers)
          },
        }),
      ],
    }
  },
  transformer: superjson,
}

export const trpc = createTRPCNext<ClaimAppRouter>(config)
